export default __webpack_public_path__ + "static/media/Hair_19_F_C2.a7ca9b72.svg";